/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import R from 'ramda'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { TextField } from 'generic/form'
import { RaisedButton, CircularProgress } from 'material-ui'

import BaseValidation from 'components/common/BaseValidation'
import { messages } from 'constants/messages'
import * as actions from 'actions/ApplicantPrestation'
import Request from 'generic/request/Request'

class PrestationModification extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)

    this.state = {
      modification: undefined,
      errors: {
        errorMessage: undefined,
        errorFields: {}
      },
      send: false,
      loading: false
    }
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
    actions.getPrestationModification(this.props.match.params.token)
      .then((result) => {
        this.setState({
          modification: result,
          loading: false
        })
      })
      .catch((error) => {
        if (error && error.response.status === 404) {
          this.setState({
            errors: {
              ...this.state.errors,
              errorMessage: error.response.data.errors[0].user_message,
            },
            loading: false
          })
        }
      })
  }

  handleChange(event, value) {
    const name = event.target.name

    this.setState({
      modification: {
        ...this.state.modification,
        [name]: value
      },
      errors: {
        errorMessage: undefined,
        errorFields: {}
      }
    })
  }

  handleLogin() {
    this.props.history.push({pathname: '/login/'})
  }

  handleSend() {
    this.setState({
      loading: true
    })

    actions.savePrestationModification(this.props.match.params.token, this.state.modification)
      .then((result) => {
        this.setState({
          send: true,
          loading: false
        })
      })
      .catch((error) => {
        if (error && (error.status === 400 || error.status === 401)) {
          this.setState({
            errors: {
              ...this.state.errors,
              errorMessage: R.path(['data', 'errors', 0, 'user_message'], error),
              errorFields: Request.getFieldErrorObject(error.data.field_errors)
            },
            loading: false
          })
        }
      })
  }

  render () {
    const modification = this.state.modification

    return (
      <BaseValidation>
        {
          this.state.errors.errorMessage && !Object.keys(this.state.errors.errorFields).length
            ? <div
              style={{...styles.message,...{color: 'red'}}}
            >
              {this.state.errors.errorMessage}
            </div>
            : <div>
              {
                this.state.send
                  ? <div style={{textAlign: 'center'}}>
                    <div style={styles.message}>
                      {this.props.intl.formatMessage(messages.PRESTATION_MODIFICATION_SEND)}
                    </div>
                    <RaisedButton
                      label={this.props.intl.formatMessage(messages.BACK_TO_LOGIN)}
                      primary={true}
                      onClick={this.handleLogin}
                      style={styles.button}
                    />
                  </div>
                  : <div>
                    <h2 style={{textAlign: 'center'}}>
                      {this.props.intl.formatMessage(messages.PRESTATION_MODIFICATION)} {modification ? modification.prestation_id : undefined}
                    </h2>
                    <div style={{marginBottom: 5}}>
                    {this.props.intl.formatMessage(messages.PRESTATION_MODIFICATION_DESCRIPTION)}
                    </div>
                    <div style={styles.form}>
                      {
                        this.state.loading || !modification
                          ? <CircularProgress
                            style={{paddingLeft: '45%'}}
                            size={100}
                          />
                          : <div>
                            <div className='row'>
                              <div className='col-md-6 col-xs-12'>
                                <TextField
                                  floatingLabelText={this.props.intl.formatMessage(messages.CUSTOMER_NAME)}
                                  onChange={this.handleChange}
                                  name='name'
                                  value={modification.name}
                                  errorText={this.state.errors.errorFields.name}
                                  meta={{mandatory: true}}
                                />
                              </div>

                              <div className='col-md-6 col-xs-12'>
                                <TextField
                                  floatingLabelText={this.props.intl.formatMessage(messages.CUSTOMER_EMAIL)}
                                  onChange={this.handleChange}
                                  name='email'
                                  value={modification.email}
                                  errorText={this.state.errors.errorFields.email}
                                  meta={{mandatory: true}}
                                />
                              </div>

                              <div className='col-md-6 col-xs-12'>
                                <TextField
                                  floatingLabelText={this.props.intl.formatMessage(messages.CUSTOMER_PHONE)}
                                  onChange={this.handleChange}
                                  name='phone'
                                  value={modification.phone}
                                  errorText={this.state.errors.errorFields.phone}
                                  meta={{mandatory: true}}
                                />
                              </div>
                            </div>

                            <div className='row'>
                              <div className='col-md-12 col-xs-12'>
                                <TextField
                                  floatingLabelText={this.props.intl.formatMessage(messages.CUSTOMER_COMMENT)}
                                  onChange={this.handleChange}
                                  name='comments'
                                  meta={{mandatory: true}}
                                  multiLine={true}
                                  rows={4}
                                  rowsMax={4}
                                  value={modification.comments}
                                  errorText={this.state.errors.errorFields.comments}
                                />
                              </div>
                            </div>

                            <div className='row'>
                              <div className='col-md-4 col-md-offset-8 col-xs-5 col-xs-offset-7'>
                                  <RaisedButton
                                    label={this.props.intl.formatMessage(messages.CANCEL_COMMENT)}
                                    style={{marginTop: 5, marginLeft: 5, float: 'right'}}
                                    onClick={this.handleLogin}
                                  />
                                  <RaisedButton
                                    label={this.props.intl.formatMessage(messages.SEND_COMMENT)}
                                    primary={true}
                                    style={{marginTop: 5, float: 'right'}}
                                    onClick={this.handleSend}
                                  />
                                </div>
                              </div>
                            </div>
                      }
                    </div>
                  </div>
              }
            </div>
        }
      </BaseValidation>
    )
  }
}

const styles = {
  form: {
    boxShadow: '0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)',
    padding: '15px 15px 15px',
    background: '#fff',
    minHeight: '35vh',
  },
  message: {
    fontWeight: 300,
    fontSize: '1.25rem',
    textAlign: 'center'
  },
  button: {
    minWidth: 200,
    marginTop: 30,
    height: 40
  }
}

export default injectIntl(PrestationModification)



// WEBPACK FOOTER //
// ./src/components/applicant/PrestationModification.js